import { css } from '@emotion/core';
import React from 'react';

import { getDecision, isDecisionScore, isSparkScore } from 'shared/models/profile-score';
import { ProfileScore } from '../graphql/queries/profile-score';
import { useAIProfileScoreDetails } from '../hooks/use-ai-profile-score-details';
import { DecisionScore } from './decision-score';
import { SparkScore } from './spark-score';
import { StarRating } from './star-rating';

const styles = css`
    position: absolute;
    white-space: nowrap;
    right: 32px;
    top: 50%;
    transform: translateY(-50%);
`;

export const AIProfileScore: React.FC<{ score: ProfileScore }> = ({ score }) => {
    const { showScoreDetails } = useAIProfileScoreDetails();

    const handleScoreClick = () => {
        showScoreDetails(score);
    };

    if (!score) return null;

    const scoreElement = isSparkScore(score.generationInfo) ? (
        <SparkScore score={score.score} onClick={handleScoreClick} />
    ) : isDecisionScore(score.generationInfo) ? (
        <DecisionScore decision={getDecision(score.generationInfo, score.score)} onClick={handleScoreClick} />
    ) : (
        <StarRating rating={score.score} onClick={handleScoreClick} tooltip="AI Score, click for details" />
    );

    return <div css={styles}>{scoreElement}</div>;
};
